import React, { useState } from "react";
import { Button, Checkbox } from "@jugl-web/ui-components";
import { cx } from "@jugl-web/utils/cx";
import { format } from "date-fns";
import { useSubscriptionV2 } from "@web-src/modules/cx/providers/SubscriptionV2Provider";

const QUICK_REASONS = [
  "I found better product",
  "I don't need it anymore",
  "Some features is missing",
];

interface CancelPlanAlertContentProps {
  onCancel: () => void;
  onDowngrade: (feedback: string) => void;
}

export const CancelPlanAlertContent: React.FC<CancelPlanAlertContentProps> = ({
  onCancel,
  onDowngrade,
}) => {
  const { currentPlan, subscription } = useSubscriptionV2();
  const [isConfirmed, setIsConfirmed] = useState(false);
  const [feedback, setFeedback] = useState("");

  const formattedDate = subscription?.current_period_end
    ? format(new Date(subscription.current_period_end), "MMM dd, yyyy")
    : "";

  return (
    <div className="flex flex-col gap-14">
      <div className="flex flex-col gap-[18px]">
        <div className="flex flex-col gap-[10px]">
          <p className="font-secondary text-dark-700 text-sm leading-[1.5]">
            You&apos;re about to cancel your{" "}
            <span className="bg-gradient-to-r from-[#2196F3] to-[#8A41D3] bg-clip-text font-medium text-transparent">
              {currentPlan?.name} Plan
            </span>
            . Plan & Add-ons features will be active till the end of the billing
            cycle
            {formattedDate ? ` on ${formattedDate}` : ""}
          </p>
        </div>
        <label className="flex cursor-pointer items-center gap-2">
          <Checkbox
            isChecked={isConfirmed}
            onChange={(e) => setIsConfirmed(e.target.checked)}
            size="sm"
          />
          <span className="font-secondary text-dark-900 text-xs">
            I understand and confirm the action
          </span>
        </label>
      </div>

      <div className="flex flex-col gap-3">
        <div className="relative">
          <span className="font-secondary text-dark-600 absolute -top-2 left-3 bg-white px-2 text-xs">
            Tell us what can be improved
          </span>
          <textarea
            className="font-secondary text-dark border-grey-300 h-[100px] w-full resize-none rounded-xl border border-solid p-5 text-sm outline-none"
            placeholder="Enter"
            value={feedback}
            onChange={(e) => setFeedback(e.target.value)}
          />
        </div>
        <div className="flex flex-wrap gap-2.5 px-1">
          {QUICK_REASONS.map((reason) => (
            <button
              key={reason}
              type="button"
              className={cx(
                "font-secondary cursor-pointer rounded-3xl border border-solid px-[18px] py-2 text-[13px] font-medium transition-colors",
                feedback === reason
                  ? "border-primary-500 bg-primary-50 text-dark"
                  : "text-dark border-[#DEDEE4] bg-white"
              )}
              onClick={() =>
                setFeedback((prev) => (prev === reason ? "" : reason))
              }
            >
              {reason}
            </button>
          ))}
        </div>
      </div>

      <div className="flex gap-4">
        <Button
          color="grey"
          className="h-10 w-[140px] shrink-0"
          onClick={onCancel}
        >
          Cancel
        </Button>
        <Button
          className="h-10 flex-1"
          style={{
            backgroundColor: "#EA5353",
            opacity: isConfirmed ? 1 : 0.4,
            borderColor: "#EA5353",
          }}
          isDisabled={!isConfirmed}
          onClick={() => onDowngrade(feedback)}
        >
          Cancel Plan
        </Button>
      </div>
    </div>
  );
};
